module.exports = __webpack_public_path__ + "static/Disability-in-the-Bush-Tiwi-2020-08-27-4f8d4f6a69b8f85191dea97d00546ddf.mp3";